import React from 'react'
import './HdSdFilter.css';
import { Form } from 'react-bootstrap';
import hdIcon from '../../../../images/img/hd-icon.svg'
import { Switch } from '@material-ui/core';
export default function HdSdFilter(props) {
  const{isHd,onHdChangeHD} = props;
  return (
    <div className='hdSdFilterContainer'>
      <div className='isHdImage'>
      <img  src={hdIcon} style={{marginRight:'2%'}}></img>
      </div>
       
         <div className='isHdFont' >
         <p> View Hd Channels</p>
         </div>

        
      <div className='isHdSwitch'>

        <Switch checked={isHd} onClick={()=>onHdChangeHD()} / >
      </div>
 
         
    </div>
  )
}
